import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import 'chart.js/auto';
import { Chart } from '@totalsoft/rocket-ui';
import { getChartColors } from 'components/dashboard/utils';
import { useTheme } from '@mui/material';

const DashboardPieChart = ({ indicator }) => {
  const theme = useTheme();

  const labels = useMemo(() => indicator.pie.map(item => item.label), [indicator]);

  const datasets = useMemo(
    () => [
      {
        data: indicator.pie.map(item => item.value),
        backgroundColor: getChartColors(theme.palette.primary.main, indicator.pie.length),
        hoverBorderWidth: 3,
        cutout: '65%',
        borderRadius: 10,
        spacing: 3
      }
    ],
    [indicator, theme]
  );

  const data = useMemo(() => ({ labels, datasets }), [labels, datasets]);

  return (
    <Chart
      title={indicator.title}
      type='doughnut'
      data={data}
      cardProps={{ sx: { height: '100%' } }}
      height={300}
      options={{
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              usePointStyle: true,
              padding: 15
            }
          }
        }
      }}
    />
  );
};

DashboardPieChart.propTypes = {
  indicator: PropTypes.object.isRequired
};

export default DashboardPieChart;
